"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _MessageList = _interopRequireDefault(require("./MessageList"));
var _ChannelList = _interopRequireDefault(require("./ChannelList"));
var _default = exports.default = {
  components: {
    MessageList: _MessageList.default,
    ChannelList: _ChannelList.default
  },
  props: ['network'],
  data() {
    return {
      pluginUiElements: _GlobalApi.default.singleton().serverViewPlugins
    };
  },
  computed: {
    hasMessages() {
      return this.network.serverBuffer().getMessages().length > 0;
    },
    serverBuffer() {
      return this.network.serverBuffer();
    },
    restrictedServer() {
      return this.$state.setting('restricted');
    },
    networkConnected() {
      return this.network.state === 'connected';
    }
  },
  watch: {
    networkConnected() {
      this.$nextTick(() => {
        // Vue won't update the tabs being displayed here so we to
        // manually update a property to force a re-render of the tabs
        this.$refs.tabs.a++;
      });
    }
  },
  created() {
    this.listen(this.$state, 'server.tab.show', tabName => {
      this.showTab(tabName);
    });
  },
  mounted() {
    this.serverBuffer.active_tab = 'messages';
  },
  methods: {
    showTab(tabName) {
      this.$refs.tabs.setActiveByName(tabName);
    },
    tabChanged(tabName) {
      const isMessages = tabName === 'messages';
      this.serverBuffer.active_tab = tabName;
      this.serverBuffer.isVisible = isMessages;
      this.serverBuffer.show_input = isMessages;
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["ServerView"]
window._app_exports.components.ServerView = exports.default ? exports.default : exports;
